import { render, staticRenderFns } from "./ResearchGroupInfo.html?vue&type=template&id=798c649b&scoped=true&external"
import script from "./ResearchGroupInfo.vue?vue&type=script&lang=js"
export * from "./ResearchGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./ResearchGroupInfo.scss?vue&type=style&index=0&id=798c649b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c649b",
  null
  
)

export default component.exports